<template>
    <div class="my-orders">
        <h3 class="mb-3">Affiliate Posts</h3>

        <div v-if="loading">
            <content-placeholders>
                <content-placeholders-text :lines="5" />
            </content-placeholders>
        </div>

        <div v-if="saving">
            Saving <font-awesome-icon :icon="['fad', 'circle-notch']" spin />
        </div>

        <div v-else>
            <div v-show="affiliate_posts && affiliate_posts.length" role='tablist'>
                <div v-for="(post, index) in affiliate_posts" :key="index" class='card post'>
                    <h5 class="card-header d-flex" v-b-toggle="'card-' + index">
                        <div class="align-self-center mr-3">
                            <div>{{post.title}}</div>
                            <div class="text-muted">
                                <small>By: {{post.affiliate_full_name}}</small>
                            </div>

                            <!-- -- {{post.reviewed_at}}-- {{post.shared}} -->
                        </div>
                        <div class="text-muted align-self-center ml-auto">
                            <!-- {{post.total | currency}} -->

                            <button class="btn btn-secondary" @click="markPostReviewed(post.id)">Mark Reviewed</button>
                            <button class="btn btn-primary" @click="sharePost(post.id)">Share</button>
                        </div>
                    </h5>

                    <div class="card-body">
                        <div v-html="post.content"></div>
                    </div>

                    <div class="card-footer">
                        <span class="text-muted">Created: {{post.created_at}}</span>
                    </div>
                </div>
            </div>
            <div v-if="!affiliate_posts || affiliate_posts && !affiliate_posts.length">
                <div class="alert alert-danger">
                    <!-- 0 affiliate_posts -->
                    You do not have any affiliate posts
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.btn + .btn {
    margin-left: .25rem;
}
.order + .order {
    margin-top: .25rem;
}
.order .card-header {
    cursor: pointer;
}
// .order:nth-child(even) .card-header {
//         background-color: rgba(0, 0, 0, 0.06);
// }
.order .caret-up {
    display: inline-block;
}
.order .collapsed .caret-up {
    display: none;
}
.order .caret-down {
    display: none;
}
.order .collapsed .caret-down {
    display: inline-block;
}

.order.large .table-responsive {
    max-height: 283px;
    overflow: scroll;
}

.order.large .table-responsive::-webkit-scrollbar {
    -webkit-appearance: none;
}

.order.large .table-responsive::-webkit-scrollbar:vertical {
    width: 11px;
}

.order.large .table-responsive::-webkit-scrollbar:horizontal {
    height: 11px;
}

.order.large .table-responsive::-webkit-scrollbar-thumb {
    border-radius: 8px;
    border: 2px solid white; /* should match background, can't be transparent */
    background-color: rgba(0, 0, 0, .5);
}
</style>

<script>
import { mapState } from 'vuex'


export default {
    data: () => ({
        loading: false
        , saving: false
    }),
    computed: mapState({
        affiliate_posts: state => state.affiliate.affiliate_posts,
        reviewedAffiliatePosts () {
            let affiliate_posts = []

            _.forEach(this.affiliate_posts, affiliate_post => {
                if (affiliate_post.reviewed_at) {
                    affiliate_posts.push(affiliate_post)
                }
            })

            return affiliate_posts
        }
    }),
    methods: {
        markPostReviewed (id) {
            this.$swal({
                text: 'Are you sure you want to mark this post reviewed?',
                showCancelButton: true,
                confirmButtonText: 'Mark Reviewed',
                confirmButtonClass: 'btn btn-danger',
                cancelButtonClass: 'btn btn-light',
                buttonsStyling: false
            }).then((result) => {
                if (result.value) {
                    this.saving = true

                    this.$http({
                        'url': 'dashboard/affiliate/post/reviewed/' + id,
                        'method': 'GET'
                    }).then((response) => {
                        this.saving = false

                        this.$store.dispatch('getAffiliatePosts')

                        this.$swal({
                            toast: true,
                            html: 'Post Marked Reviewed',
                            type: 'success',
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 3000
                        })
                    })
                }
            })

        },
        sharePost (id) {
            this.$swal({
                text: 'Are you sure you want to share this post?',
                showCancelButton: true,
                confirmButtonText: 'Share Post',
                confirmButtonClass: 'btn btn-danger',
                cancelButtonClass: 'btn btn-light',
                buttonsStyling: false
            }).then((result) => {
                if (result.value) {
                    this.saving = true

                    this.$http({
                        'url': 'dashboard/affiliate/post/share/' + id,
                        'method': 'GET'
                    }).then((response) => {
                        this.saving = false
                        
                        this.$store.dispatch('getAffiliatePosts')
                        
                        this.$swal({
                            toast: true,
                            html: 'Post Shared',
                            type: 'success',
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 3000
                        })
                    })
                }
            })
            
        },

    },
    mounted () {
        // this.$store.dispatch('getAffiliatePosts')
    },
}
</script>
